import { render, staticRenderFns } from "./multichoice.vue?vue&type=template&id=4c5d3332&scoped=true&"
import script from "./multichoice.vue?vue&type=script&lang=js&"
export * from "./multichoice.vue?vue&type=script&lang=js&"
import style0 from "./multichoice.vue?vue&type=style&index=0&id=4c5d3332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d3332",
  null
  
)

export default component.exports